<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25 font-bold text-primary" href="#" target="_blank">Multicedi</b-link>
    </span>

    <span class="float-md-right d-none d-md-block">
      Designed by
      <b>Lascò</b>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
